import { BotonExportarExcel, Checkbox, Group, TablaSkeleton, Table, Tbody, Td, Text, Th, Thead, Tr } from "@/components/ui";
import type { CuentaContable } from "@/lib/types";
import type { ClaveSatClaveCuenta } from "../services/clave-sat-clave-cuenta-service";
import { ClaveSatClaveCuentaRow } from "./ClaveSatClaveCuentaRow";

/** Tabla del catálogo de mapeos clave SAT → cuenta · cada fila controla su modo edición. */
export function ClavesSatClavesCuentaTable({
  cargando = false,
  mapeos,
  cuentas,
  obtenerFilasExport,
  seleccionadas,
  onToggle,
  onToggleTodasPagina,
}: {
  /** Primera carga (sin caché) · filas skeleton bajo el encabezado real. */
  cargando?: boolean;
  mapeos: ClaveSatClaveCuenta[];
  cuentas: CuentaContable[];
  /** Con paginado server-side: callback que trae TODAS las páginas para el export. */
  obtenerFilasExport?: () => Promise<ClaveSatClaveCuenta[]>;
  seleccionadas: Set<string>;
  onToggle: (id: string) => void;
  /** Marca/desmarca todas las filas de la página actual. */
  onToggleTodasPagina: () => void;
}) {
  const todasPaginaSeleccionadas = mapeos.length > 0 && mapeos.every((m) => seleccionadas.has(m.id));
  const algunaPaginaSeleccionada = mapeos.some((m) => seleccionadas.has(m.id));
  const estadoHeader: boolean | "indeterminate" = todasPaginaSeleccionadas
    ? true
    : algunaPaginaSeleccionada
      ? "indeterminate"
      : false;
  return (
    <div className="overflow-x-auto">
      <Group justify="flex-end" className="mb-2">
        <BotonExportarExcel
          archivo="mapeos-clave-cuenta"
          hoja="Cuentas por clave"
          filas={obtenerFilasExport ? undefined : mapeos}
          obtenerFilas={obtenerFilasExport}
          columnas={[
            { header: "Clave SAT", value: (m) => m.claveSat },
            { header: "Descripción clave", value: (m) => m.claveSatDescripcion },
            { header: "Cuenta código", value: (m) => m.cuentaCodigo },
            { header: "Cuenta nombre", value: (m) => m.cuentaNombre },
            { header: "Nombre", value: (m) => m.nombre },
            { header: "Estado", value: (m) => (m.activo ? "Activo" : "Inactivo") },
          ]}
        />
      </Group>
      <Table verticalSpacing="sm">
        <Thead>
          <Tr>
            <Th>
              <Checkbox
                checked={estadoHeader}
                onCheckedChange={() => onToggleTodasPagina()}
                aria-label="Seleccionar todas las de esta página"
              />
            </Th>
            <Th>Clave SAT</Th>
            <Th>Descripción clave</Th>
            <Th>Cuenta</Th>
            <Th>Nombre</Th>
            <Th>Estado</Th>
            <Th />
          </Tr>
        </Thead>
        {cargando ? (
          <TablaSkeleton dentroDeTabla columnas={[{}, {}, {}, {}, {}, {}, { align: "right" }]} filas={15} conCheckbox />
        ) : (
          <Tbody>
            {mapeos.map((m) => (
              <ClaveSatClaveCuentaRow
                key={m.id}
                mapeo={m}
                cuentas={cuentas}
                seleccionada={seleccionadas.has(m.id)}
                onToggleSeleccion={() => onToggle(m.id)}
              />
            ))}
            {mapeos.length === 0 && (
              <Tr>
                <Td colSpan={7}>
                  <Text size="sm" c="dimmed" ta="center" className="py-3">
                    Sin mapeos. Crea el primero con "Nueva cuenta por clave" o impórtalos desde Excel.
                  </Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        )}
      </Table>
    </div>
  );
}
